import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ role = "user", children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" data-testid="route-loading-spinner" />
      </div>
    );
  }
  if (!user) {
    const to = role === "admin" ? "/admin/login" : "/login";
    return <Navigate to={to} state={{ next: location.pathname }} replace />;
  }
  if (role === "admin" && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (role === "user" && user.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
